import { useState } from 'react';
import { AxiosError, AxiosRequestConfig } from 'axios';
import useError from 'components/ErrorProvider/useError';
import { downloadFile } from 'helper';
import { exportPartnersRatingByPartnerExcel } from '../api';

export function useExportPartnersRatingByPartnerExcelReport() {
  const [loading, setLoading] = useState(false);

  const { addError } = useError();

  const exportPartnersRatingByPartnerExcelReport = async (config?: AxiosRequestConfig) => {
    setLoading(true);

    try {
      downloadFile(
        await exportPartnersRatingByPartnerExcel(config),
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'Отчет по партнерам.xlsx',
      );
    } catch (error) {
      addError((error as AxiosError).response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return { loading, exportPartnersRatingByPartnerExcelReport };
}
